(function () {
    'use strict';

    a3_cabin_reports.factory('ScheduleAcknowledgeFactory', ScheduleAcknowledgeFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ScheduleAcknowledgeFactory
    * @description 
    *   Get list, Update list & Acknowledge schedule changes
    * @ngInject
    */
    function ScheduleAcknowledgeFactory(localStorageMD5Service, GenericService, $http, apiUrl, defaultCalendarDate) {

        /**
         * Initialize the ScheduleChanges
         * @memberof ScheduleAcknowledgeFactory
         */
        function ScheduleChanges() {
            this.dates = [];
            this.showScheduleChangesModal = false;
        }

        var objType = 'ScheduleChanges';
        var objCallback = ScheduleChanges;

        var response = {
            success: false,
            message: '',
            Results: []
        };

        var service = {
            setAllScheduleChangesToStorage: setAllScheduleChangesToStorage,
            getScheduleChangesFromStorage: getScheduleChangesFromStorage,
            updateShowScheduleChangesModal: updateShowScheduleChangesModal,
            showScheduleChangesModal: showScheduleChangesModal,
            hasScheduleChanges: hasScheduleChanges,
            acknowledgeChanges: acknowledgeChanges
        };

        /**
         * Save All Schedule changes
         * @param {array} objList 
         */
        function setAllScheduleChangesToStorage(objList) {
            if (objList == null || !objList.length > 0) {
                GenericService.removeAll(objType);
            }
            else {
                var scheduleChanges = { dates: objList, showScheduleChangesModal: true }
                GenericService.saveOne(scheduleChanges, objType, objCallback);
            }
        }

        /**
         * Get all Schedule changes
         */
        function getScheduleChangesFromStorage() {
            var dateList = [];
            var scheduleChanges = GenericService.getOne(objType, objCallback);

            if (scheduleChanges != null && scheduleChanges.dates != null) {
                scheduleChanges.dates.forEach(function (dateS) {
                    var stringToDate = moment.utc(dateS);
                    dateList.push(stringToDate);
                });
            }

            return dateList;
        }

        /* Update scheduleChanges object to storage
        * @memberof ScheduleAcknowledgeFactory
        * @param {bool} canShowModal whether the modal can be display
        */
        function updateShowScheduleChangesModal(canShowModal) {
            var scheduleChanges = GenericService.getOne(objType, objCallback);
            scheduleChanges.showScheduleChangesModal = canShowModal;
            GenericService.saveOne(scheduleChanges, objType, objCallback);
        }

        /**
         * ShowScheduleChangesModal check
         * @memberof ScheduleAcknowledgeFactory
         * @returns {bool} returns the value of showScheduleChangesModal property
         */
        function showScheduleChangesModal() {
            var scheduleChanges = GenericService.getOne(objType, objCallback);

            if (scheduleChanges && scheduleChanges.dates != null && scheduleChanges.dates.length > 0) {
                var fistChange = moment.utc(scheduleChanges.dates[0]);
                var today = moment.utc();
                if (defaultCalendarDate) {
                    today = moment.utc(defaultCalendarDate);
                }
                var datediff = fistChange.diff(today, 'days');

                return datediff <= 1 && scheduleChanges.showScheduleChangesModal;

            } else {
                return false;
            }
        }

        function hasScheduleChanges() {
            var dates = getScheduleChangesFromStorage();
            return dates != null && dates.length > 0;
        }

        /**
         * Acknowledge Changes 
         * @param {date} dateFrom The first schedule change date
         * @param {date} dateTo The last schedule change date
         * @returns {promise} response
         */
        function acknowledgeChanges() {
            //get dates from local storage
            var datesToAcknowledge = getScheduleChangesFromStorage();

            return $http.post(apiUrl + '/ScheduleAcknowledge/AcknowledgeScheduleChanges', datesToAcknowledge, { 'Content-Type': 'application/json' })
                .then(res => updateScheduleChangesCallBack(res))
                .catch(res => acknowledgeFailedCallBack(res));
        }

        /**
         * Update Schedule changes dates
         * @param {object} res 
         * @param {object} objectToAdd 
         * @returns {object} response
         */
        function updateScheduleChangesCallBack(res) {
            response.success = res.data.success;
            if (res.data.success) {
                //update local storage
                setAllScheduleChangesToStorage(res.data.data.DatesWithChanges);
                response.message = "Success! Your Acknowledge has been sent";
                response.Results = res.data.data.Results;
            }
            else {
                response.message = res.data.errorMessage
            }

            return response;
        }

        /**
        * The callback function upon failure on submit
        * @returns {object} response
        */
        function acknowledgeFailedCallBack(res) {
            response.success = false;
            response.message = "Oops! Something went wrong"
            if (res.data.data && res.data.data.Results) {
                response.Results = res.data.data.Results;
            }
            return response;
        }



        return service;
    }
})();
